import React from "react";
import FeatureCardContent from "@shared/FeatureCardContent/FeatureCardContent";
import analysisIcon from "@icons/recommendation-icon.svg";
import actionItemsIcon from "@icons/clipboard.svg";
import { getSeasonalTheme } from "@lib/seasonalTheme";
import "./ProjectManagementCard.css";
import '@shared/FilmMotion/FilmMotion.css'

function ProjectManagementCard() {
  const theme = getSeasonalTheme();
  return (
    <article className="venture-card project-management-card">
      <FeatureCardContent
        badgeTitle="Automated Action Items"
        title="Project Management"
        text={"Vienna auto-creates action items, assigns ownership, and keeps deadlines visible across Calendar + Tasks views so round work keeps moving."}
        subtext="Less busywork. More forward motion."
        icon={<img className="project-management-card__badge-icon" src={analysisIcon} alt="" />}
      />

      <div
        className="venture-card__pane venture-card__pane--visual project-management-card__visual"
        style={{
          "--card-monet": `url(${theme.paintings.project})`,
          "--card-monet-position": "58% center",
          "--card-monet-overlay": "rgba(255, 255, 255, 0.34)",
        }}
      >
        <div className="project-management-home">
          <div className="project-management-home__overlay" />
          <div className="project-management-home__cards film-stage">
            <div className="project-management-home__card project-management-home__card--top">
              <div className="project-management-home__title-row">
                <img className="project-management-home__icon" src={actionItemsIcon} alt="" />
                <p>Action Items</p>
              </div>
              <div className="project-management-home__text">
                <p>Auto-create assignable tasks from emails, filings, and transcripts.</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </article>
  );
}

export default ProjectManagementCard;
